/* eslint-disable */
const tabbedTextImage = (element: HTMLElement) => {
  const tabContainer: HTMLElement = element.querySelector(
    ".tabs__tab-container"
  );
  const contentContainer: HTMLElement = element.querySelector(
    ".tabs__content-container"
  );

  if (!tabContainer || !contentContainer) {
    return;
  }

  // @ts-ignore
  const tabs: Array<HTMLElement> = tabContainer.querySelectorAll(".tabs__tab");
  if (!tabs.length) {
    return;
  }

  tabs.forEach((tab: HTMLElement) => {
    tab.addEventListener("click", () => {
      document
        .querySelectorAll(".tabs__tab--active, .tabs__content-wrapper--active")
        .forEach((tab) => {
          tab.classList.remove("tabs__tab--active");
          tab.classList.remove("tabs__content-wrapper--active");
        });

      tab.classList.add("tabs__tab--active");
      contentContainer
        .querySelector(`[data-content-id="${tab.dataset.tabId}"]`)
        .classList.add("tabs__content-wrapper--active");
    });
  });
};

export default tabbedTextImage;
